import React from 'react'
import Img from 'gatsby-image';
import { Container, Row, Col } from 'reactstrap';

import Cards from './components/_CardContainer';

export default (props) => {

  const chess = props.data.chess.childImageSharp.sizes;
  const training = props.data.training.childImageSharp.sizes;

  const images = { card1: chess, card2: training}

  return (
    <div>
      <Container className="my-5" >
        <h1 className="text-center text-color-title bold">{props.content.title}</h1>
        <Cards images={images} cardsData={props.content.cards}/>
      </Container>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/competency/_competencyLayout.js